import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "dashboard-area pt-120 mb-120" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "row g-lg-4 gy-5 mb-90" }
const _hoisted_4 = { class: "col-lg-9" }
const _hoisted_5 = { class: "form-wrapper" }
const _hoisted_6 = { class: "profile-form" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "section-title2" }, [
  /*#__PURE__*/_createElementVNode("h5", { class: "d-flex align-items-baseline gap-1" }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: "assets/images/icon/profile-settings.svg",
      alt: ""
    }),
    /*#__PURE__*/_createTextVNode(" Profile Settings ")
  ])
], -1)
const _hoisted_8 = { class: "change-password-area mb-40" }
const _hoisted_9 = { class: "row" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "col-lg-12" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "info-title" }, [
    /*#__PURE__*/_createElementVNode("h6", null, "Change Your Password"),
    /*#__PURE__*/_createElementVNode("div", { class: "dash" })
  ])
], -1)
const _hoisted_11 = { class: "col-md-6" }
const _hoisted_12 = { class: "form-inner mb-25" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("label", { for: "password" }, "New Password*", -1)
const _hoisted_14 = { class: "input-area" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("img", {
  src: "assets/images/icon/lock-2.svg",
  alt: ""
}, null, -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("i", {
  class: "bi bi-eye-slash",
  id: "togglePassword"
}, null, -1)
const _hoisted_17 = {
  key: 0,
  style: {"color":"red !important","font-size":"small !important","position":"relative","left":"5px","top":"0.2rem !important"}
}
const _hoisted_18 = { class: "col-md-6" }
const _hoisted_19 = { class: "form-inner mb-25" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("label", { for: "password2" }, "Confirm Password*", -1)
const _hoisted_21 = { class: "input-area" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("img", {
  src: "assets/images/icon/lock-2.svg",
  alt: ""
}, null, -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("i", {
  class: "bi bi-eye-slash",
  id: "togglePassword2"
}, null, -1)
const _hoisted_24 = {
  key: 0,
  style: {"color":"red !important","font-size":"small !important","position":"relative","left":"5px","top":"3px !important"}
}
const _hoisted_25 = { class: "col-md-12 pt-10" }
const _hoisted_26 = { class: "form-inner" }
const _hoisted_27 = ["disabled"]
const _hoisted_28 = { class: "privacy-security-area" }
const _hoisted_29 = { class: "row" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("div", { class: "col-lg-12" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "info-title" }, [
    /*#__PURE__*/_createElementVNode("h6", null, "Privacy & Security"),
    /*#__PURE__*/_createElementVNode("div", { class: "dash" })
  ])
], -1)
const _hoisted_31 = { class: "col-lg-12" }
const _hoisted_32 = { class: "single-permission mb-2" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("div", { class: "title" }, [
  /*#__PURE__*/_createElementVNode("h6", null, "Are you available to interview ?")
], -1)
const _hoisted_34 = { class: "form-check form-switch ms-auto" }
const _hoisted_35 = { class: "single-permission mb-2" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("div", { class: "title" }, [
  /*#__PURE__*/_createElementVNode("h6", null, "Receive application & update notification ")
], -1)
const _hoisted_37 = { class: "form-check form-switch ms-auto" }
const _hoisted_38 = { class: "single-permission mb-3" }
const _hoisted_39 = /*#__PURE__*/_createElementVNode("div", { class: "title" }, [
  /*#__PURE__*/_createElementVNode("h6", null, "Disable Account"),
  /*#__PURE__*/_createElementVNode("p", null, "If you log in again you will be able to see all previous information.")
], -1)
const _hoisted_40 = { class: "form-check form-switch ms-auto" }
const _hoisted_41 = { class: "col-md-12 pt-50" }
const _hoisted_42 = { class: "form-inner" }
const _hoisted_43 = {
  key: 1,
  class: "primry-btn-2 lg-btn w-unset",
  type: "button"
}
const _hoisted_44 = /*#__PURE__*/_createElementVNode("span", { class: "me-3 fs-6 text-white" }, "Processing...", -1)
const _hoisted_45 = /*#__PURE__*/_createElementVNode("i", {
  class: "fa fa-spinner fa-spin text-white ms-3",
  style: {"font-size":"24px"}
}, null, -1)
const _hoisted_46 = [
  _hoisted_44,
  _hoisted_45
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_user_menu = _resolveComponent("user-menu")!
  const _component_InputSwitch = _resolveComponent("InputSwitch")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_user_menu),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("form", _hoisted_6, [
              _hoisted_7,
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _hoisted_10,
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("div", _hoisted_12, [
                      _hoisted_13,
                      _createElementVNode("div", _hoisted_14, [
                        _hoisted_15,
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.changepass.password) = $event)),
                          type: "password",
                          name: "password",
                          onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.passCheck && _ctx.passCheck(...args))),
                          id: "password",
                          placeholder: "Password"
                        }, null, 544), [
                          [_vModelText, _ctx.changepass.password]
                        ]),
                        _hoisted_16
                      ]),
                      (!_ctx.validPass)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_17, _toDisplayString(_ctx.validationMessage), 1))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_18, [
                    _createElementVNode("div", _hoisted_19, [
                      _hoisted_20,
                      _createElementVNode("div", _hoisted_21, [
                        _hoisted_22,
                        _withDirectives(_createElementVNode("input", {
                          type: "password",
                          name: "confirmpassword",
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.confirm_pass) = $event)),
                          id: "password2",
                          onChange: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.isConfirm && _ctx.isConfirm(...args))),
                          placeholder: "Confirm Password"
                        }, null, 544), [
                          [_vModelText, _ctx.confirm_pass]
                        ]),
                        _hoisted_23
                      ]),
                      (!_ctx.confirmPass)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_24, _toDisplayString(_ctx.confirmText), 1))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_25, [
                    _createElementVNode("div", _hoisted_26, [
                      _createElementVNode("button", {
                        onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.updatePassword && _ctx.updatePassword(...args))),
                        class: "primry-btn-1 lg-btn w-unset",
                        disabled: !_ctx.confirmPass || !_ctx.validPass,
                        type: "button"
                      }, "Save Changes", 8, _hoisted_27)
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_28, [
                _createElementVNode("div", _hoisted_29, [
                  _hoisted_30,
                  _createElementVNode("div", _hoisted_31, [
                    _createElementVNode("div", _hoisted_32, [
                      _hoisted_33,
                      _createElementVNode("div", _hoisted_34, [
                        _createVNode(_component_InputSwitch, {
                          modelValue: _ctx.is_available,
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.is_available) = $event)),
                          pt: { slider: 'my-switch-slider' },
                          onChange: _cache[6] || (_cache[6] = ($event: any) => (_ctx.updateAvailable({'is_available':_ctx.is_available == true ? 'yes' : 'no'})))
                        }, null, 8, ["modelValue"])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_35, [
                      _hoisted_36,
                      _createElementVNode("div", _hoisted_37, [
                        _createVNode(_component_InputSwitch, {
                          pt: { slider: 'my-switch-slider' },
                          modelValue: _ctx.applicationShortlistedEmailAlert,
                          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.applicationShortlistedEmailAlert) = $event))
                        }, null, 8, ["modelValue"])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_38, [
                      _hoisted_39,
                      _createElementVNode("div", _hoisted_40, [
                        _createVNode(_component_InputSwitch, {
                          modelValue: _ctx.disableAccount,
                          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.disableAccount) = $event))
                        }, null, 8, ["modelValue"])
                      ])
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_41, [
                _createElementVNode("div", _hoisted_42, [
                  (!_ctx.isLoading)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.updateSettings && _ctx.updateSettings(...args))),
                        class: "primry-btn-2 lg-btn w-unset",
                        type: "button"
                      }, "Save Changes"))
                    : (_openBlock(), _createElementBlock("button", _hoisted_43, _hoisted_46))
                ])
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}